import React, { useEffect, useRef, useState } from "react";
import { Card, Button, Box, Typography, IconButton } from "@mui/material";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useAuth } from "../../../../AuthProvider";
import { useLocation } from "react-router-dom";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const TeacherTimeTable = () => {
  const tableRef = useRef();
  const navigate = useNavigate();
  const { oId ,pId} = useAuth();
  const location = useLocation();
  const { student } = location.state || {};

  const [timetableData, setTimetableData] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);



  //timeslots api 
  const fetchTimeSlots = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/dynamic-time-table/getAllTimeSlots/${oId}/${pId}`);
      const data = await response.json();
  
      if (response.ok && Array.isArray(data)) {
        const normalizedSlots = data.map((slot) => {
          const rawType = slot.type.toLowerCase();
          let normalizedType = "period";
          let label = null;
  
          if (rawType.includes("break")) {
            normalizedType = rawType.includes("lunch") ? "lunch" : "break";
            label = slot.type; // e.g., "Lunch Break", "Interval Break"
          }
  
          return {
            time: slot.timeSlot,
            type: normalizedType,
            label: label,
          };
        });
  
        setTimeSlots(normalizedSlots);
      } else {
        setTimeSlots([]);
      }
    } catch (error) {
      console.error("Error fetching time slots:", error);
      setTimeSlots([]);
    }
  };
  useEffect(() => {
    fetchTimeSlots();
  }, []);
    
  

  // useEffect(() => {
  //   const fetchTimeTableData = async () => {
  //     try {
  //       const response = await fetch(
  //         `${baseUrl}/api/teacherTimeTable/getTeacherTimeTableBasedOnTeacherId/${student?.teacherId}/${oId}`
  //       );
  //       const data = await response.json();
  //       setTimetableData(data);
  //     } catch (error) {
  //       console.error("Error fetching timetable data:", error);
  //     }
  //   };
  
  //   if (student && student?.teacherId) {
  //     fetchTimeTableData();
  //   }
  // }, [student, oId]);
  
useEffect(() => {
  const fetchTimeTableData = async () => {
    try {
      const response = await fetch(
        `${baseUrl}/api/teacherTimeTable/getTeacherTimeTableBasedOnTeacherId/${student?.teacherId}/${oId}/${pId}`
      );

      if (!response.ok) {
        throw new Error(`API error: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();

      // Optional: Check if data is in expected format (e.g., array)
      if (Array.isArray(data)) {
        setTimetableData(data);
      } else {
        console.warn("Unexpected timetable data format:", data);
        setTimetableData([]); // fallback to empty
      }
    } catch (error) {
      console.error("Error fetching timetable data:", error);
      setTimetableData([]); // fallback on error
    }
  };

  if (student?.teacherId && oId) {
    fetchTimeTableData();
  }
}, [student, oId]);

  

  const handlePrint = () => {
    window.print(); // Directly trigger print on the current page
  };

  const handleDownloadPDF = () => {
    html2canvas(tableRef.current, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();

      // Add "TIME TABLE" at the top of the PDF with reduced bottom margin
      pdf.setFontSize(18); // Larger font size for the title
      pdf.setTextColor("#2e2a54"); // Title color
      pdf.setFont("bold");
      pdf.text("Time Table", 105, 20, { align: "center" }); // Centered title

      // Add the teacher's name and ID aligned to the left below the title
      pdf.setFontSize(12); // Font size for name and ID
      pdf.setTextColor("#6c63ff"); // Blue color for the labels

      // Set the left alignment for name and employee ID
      const leftMargin = 20; // Left alignment margin
      const lineHeight = 7; // Space between lines (name and ID)

      // Add Name and ID
      pdf.text("Teacher Name:", leftMargin, 30); // Label aligned to the left
      pdf.setFont("bold"); // Bold for value
      pdf.setTextColor("#000000"); // Black for value
      pdf.text(
        `${student?.teacherFirstName} ${student?.teacherLastName}`,
        leftMargin + 25,
        30
      );

      // Employee ID with same formatting
      pdf.setFont("normal"); // Back to normal font for label
      pdf.setTextColor("#6c63ff"); // Blue for label
      pdf.text("Employee ID:", leftMargin, 30 + lineHeight); // Label
      pdf.setFont("bold"); // Bold for value
      pdf.setTextColor("#000000"); // Black for value
      pdf.text(student?.teacherId, leftMargin + 25, 30 + lineHeight); // Value

      // Add the table image below the text (adjust the y-coordinate to fit under the name and ID)
      pdf.addImage(imgData, "PNG", 10, 45, 190, 0); // Adjust y-position to fit below the name and ID

      // Save the PDF
      pdf.save("TimeTable.pdf");
    });
  };

  const normalizeTimeSlot = (timeSlot) => {
    // Normalize the timeSlot to match the format used in the timeSlots array
    return timeSlot
      .replace(/\s*to\s*/i, " - ") // Replace 'to' with ' - '
      .replace(/\s*AM|\s*PM/gi, ""); // Remove AM/PM for easier matching
  };

  const renderTableCell = (day, timeSlot) => {
    const normalizedTimeSlot = normalizeTimeSlot(timeSlot); // Normalize the time slot for comparison

    const periodData = timetableData.find(
      (item) =>
        item.dayName === day &&
        normalizeTimeSlot(item.timeSlot) === normalizedTimeSlot
    );

    console.log("I am period Data:", periodData); // Debugging log

    if (periodData) {
      return (
        <>
          <strong style={{ fontSize: "10px" }}>{periodData.romanNumberClass}</strong>{" "}
          <br />
          <span style={{ fontSize: "10px" }}>{periodData.sections}</span> <br />
          <span style={{ fontSize: "10px" }}>{periodData.subject}</span>
        </>
      );
    }

    // Return "NA" if no data is available for the given day and time slot
    return "---";
  };

  return (
    <div
      style={{
        marginTop: "5%",
        padding: "15px",
        boxShadow: "5px 5px 15px rgba(0,0,0,0.2)",
        backgroundColor: "white",
        // height: "820px",
        marginRight: "15px",
        marginLeft: "15px",
        // marginBottom: "10px",
      }}
    >
      <Box display="flex" alignItems="center" sx={{ marginBottom: 2 }}>
        {/* Back Icon and Main Heading Side by Side */}
        <Box display="flex" alignItems="center" gap={2}>
          <IconButton
            onClick={() => navigate(-1)}
            sx={{ color: "#2e2a54" }}
          >
            <KeyboardBackspaceIcon fontSize="medium" />
          </IconButton>
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "#2e2a54",
              display: "flex",
              alignItems: "center",
            }}
          >
           Teacher Time Table
            {/* <h4
              style={{
                color: "#3b8a6d",
                marginLeft: "5px",
                textDecoration: "underline",
              }}
            >
              {student.teacherFirstName} {student.teacherLastName} #
              {student.teacherId}
            </h4> */}
          </Typography>
        </Box>

        {/* Flexible space to push buttons to the right */}
        <Box sx={{ flexGrow: 1 }} />

        {/* Action Buttons with Effects */}
        <Box display="flex" gap={2}>
          <Button
            variant="contained"
            onClick={handlePrint}
            sx={{
              backgroundColor: "#3b5998",
              color: "#fff",
              "&:hover": { backgroundColor: "#2d4373" },
              transition: "background-color 0.3s ease",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              marginRight: "29px",
              // marginTop: "29px",
            }}
          >
            Print
          </Button>

          {/* <Button
            variant="contained"
            onClick={handleDownloadPDF}
            sx={{
              backgroundColor: "#e91e63",
              color: "#fff",
              "&:hover": { backgroundColor: "#c2185b" },
              transition: "background-color 0.3s ease",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            }}
          >
            Download PDF
          </Button> */}
        </Box>
      </Box>

      <Card
        id="print-section"
        style={{
          padding: "10px 20px 20px 20px",
          boxShadow: "5px 5px 15px rgba(0, 0, 0, 0.2)",
          width: "97%", // Fixed typo from "Width" to "width",
          margin: "auto",
        }}
      >
        {/* Time Table Title */}
        <Typography
          variant="h4"
          style={{
            textAlign: "center",
            fontWeight: "bold",
            paddingBottom: "10px",
            marginBottom: "5px",
          }}
        >
          Time Table
        </Typography>
        {/* Teacher's Name and ID Section */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          style={{ marginBottom: "10px" }}
        >
          {/* Name and ID aligned to the left */}
          <div>
            <Typography
              variant="h6"
              style={{ fontWeight: "bold", color: "#6c63ff" }}
            >
              Teacher Name:{" "}
              <span style={{ fontWeight: "bold", color: "#000" }}>
                {student?.teacherFirstName} {student?.teacherLastName}
              </span>
            </Typography>
            <Typography
              variant="h6"
              style={{ fontWeight: "bold", color: "#6c63ff" }}
            >
              Teacher ID:{" "}
              <span style={{ fontWeight: "bold", color: "#000" }}>
                {student?.teacherId}
              </span>
            </Typography>
          </div>
        </Box>

        {/* Time Table */}
        <table
          ref={tableRef}
          style={{
            width: "100%",
            borderCollapse: "collapse",
            textAlign: "center",
            tableLayout: "fixed",
            wordWrap: "break-word",
          }}
        >
          <thead>
            <tr>
              <th style={headerStyle}>DAY / HOUR</th>
              {timeSlots.map((slot, index) => (
                <th key={index} style={headerStyle}>
                  {slot.time}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].map(
              (day, dayIndex) => (
                <tr key={day}>
                  <td
                    style={{
                      ...cellStyle,
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                      fontSize: "11px",
                    }}
                  >
                    {day}
                  </td>

                  {timeSlots.map((slot, index) => {
          if (slot.type === "period") {
            return (
              <td key={`period-${index}`} style={cellStyle}>
                {renderTableCell(day, slot.time)}
              </td>
            );
          }

          if (dayIndex === 0) {
            return (
              <td
                key={`break-${index}`}
                rowSpan={6}
                style={{
                  ...cellStyle,
                  writingMode: "vertical-rl",
                  textAlign: "center",
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                  width: "5%",
                  backgroundColor: slot.type === "lunch" ? "#e0e0e0" : "#e0e0e0",
                }}
              >
                {slot.label || slot.type.toUpperCase()}
              </td>
            );
          }

          return null;
        })}

                </tr>
              )
            )}
          </tbody>
        </table>


      </Card>

      {/* Print-only CSS */}
      <style>
  {`
    @media print {
      body * {
        visibility: hidden;
      }

      #print-section, #print-section * {
        visibility: visible;
      }

      #print-section {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        padding: 0 !important;
        margin: 0 auto !important;
        box-shadow: none !important;
      }

      #print-section table {
        width: 100% !important;
        border-collapse: collapse !important;
        table-layout: fixed !important; /* Ensures consistent column width */
      }

      #print-section th,
      #print-section td {
        border: 1px solid #000 !important;
        padding: 6px !important;
        font-size: 12px !important;
        white-space: normal !important;  /* allow wrapping */
        word-wrap: break-word !important;
        overflow-wrap: break-word !important;
        max-width: 150px !important;
        text-align: center;
        vertical-align: middle;
      }

      #print-section td:nth-child(1),
      #print-section th:nth-child(1) {
        width: 120px !important; /* Enough room for long day names like Wednesday */
      }
    }
  `}
</style>

    </div>
  );
};

const headerStyle = {
  border: "1px solid black",
  padding: "10px",
  backgroundColor: "#f2f2f2",
};

const cellStyle = {
  border: "1px solid black",
  padding: "10px",
  height: "50px",
  fontWeight: "bold",
};

export default TeacherTimeTable;